import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { Icon } from 'components/common';
import Copy from 'components/common/Copy';
import { colours } from 'utils/theme';
import { emailRequestStatus } from './models';

const emailStatusToTooltip = {
  [emailRequestStatus.InProgress]: 'Allow 3-5 business days for results',
  [emailRequestStatus.BadEmail]:
    'This email failed to pass our verification process',
  [emailRequestStatus.PendingVerification]: 'Pending Verification',
};

export const Status = ({ status, email }) => {
  if (status === emailRequestStatus.InProgress) {
    return (
      <>
        Research in progress
        <StatusTooltip status={status} />
      </>
    );
  }

  if (status === emailRequestStatus.NotFound) {
    return <>A valid email address cannot be found</>;
  }

  return (
    <>
      Email found:
      <Copy value={email} style={{ marginLeft: 5 }} />
      <StatusTooltip status={status} />
    </>
  );
};

export const StatusTooltip = ({ status }) => {
  const tooltipTitle = emailStatusToTooltip[status];
  if (!tooltipTitle || !tooltipTitle.length) return null;
  return (
    <Tooltip title={tooltipTitle} placement='right'>
      <div style={{ cursor: 'pointer', marginTop: -2 }}>
        <Icon icon='help' color={colours.teal} size='1x' />
      </div>
    </Tooltip>
  );
};

Status.propTypes = {
  status: PropTypes.number.isRequired,
  email: PropTypes.string,
};

Status.defaultProps = {
  email: '',
};
